import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2, Plus } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function AccountBilling() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/me/entitlements").then(({ data }) => setData(data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);
  const act = async (product, action) => {
    try {
      await api.post(`/billing/subscription/${product}/${action}`);
      toast.success(action === "cancel" ? "Subscription canceled" : "Subscription reactivated");
      load();
    } catch (e) { toast.error(apiErr(e)); }
  };
  if (!data) return <div className="h-screen grid place-items-center bg-background"><Loader2 className="h-7 w-7 animate-spin text-muted-foreground" /></div>;
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="account-billing-page">
      <div className="border-b border-border bg-card"><div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-3">
        <button onClick={() => navigate("/dashboard")} className="text-muted-foreground hover:text-foreground flex items-center gap-1.5 text-sm"><ArrowLeft className="h-4 w-4" /> Dashboard</button>
        <h1 className="text-lg font-bold ml-2">Billing & Subscriptions</h1>
        <button onClick={() => navigate("/billing")} className="ml-auto h-9 px-4 rounded-lg bg-[#0078d4] hover:bg-[#106ebe] text-white text-sm font-medium flex items-center gap-1.5" data-testid="add-lab-btn"><Plus className="h-4 w-4" /> Add a lab</button>
      </div></div>
      <div className="max-w-4xl mx-auto px-6 py-8 space-y-4">
        {data.legacy_access && <div className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-700 dark:text-emerald-300">Complimentary access — all labs are active on your account.</div>}
        {data.entitlements.length === 0 && !data.legacy_access && <p className="text-muted-foreground">No active subscriptions yet. <button className="text-[#0078d4] hover:underline" onClick={() => navigate("/billing")}>Browse labs</button>.</p>}
        {data.entitlements.map((e) => (
          <div key={e.product} className="rounded-xl border border-border bg-card p-4 flex items-center justify-between" data-testid={`sub-${e.product}`}>
            <div>
              <div className="font-semibold">{e.name}</div>
              <div className="text-xs text-muted-foreground">{e.source} · {e.interval || "—"} · started {String(e.start_date || "").slice(0, 10)}</div>
            </div>
            <div className="flex items-center gap-2">
              <span className={`text-xs px-2 py-0.5 rounded-full ${e.status === "ACTIVE" ? "bg-emerald-500/15 text-emerald-600" : "bg-amber-500/15 text-amber-600"}`}>{e.status}</span>
              {e.status === "ACTIVE" && e.source !== "legacy" && (
                <button data-testid={`cancel-${e.product}`} onClick={() => act(e.product, "cancel")} className="text-xs text-red-600 hover:underline">Cancel</button>
              )}
              {e.status === "CANCELED" && (
                <button data-testid={`reactivate-${e.product}`} onClick={() => act(e.product, "reactivate")} className="text-xs text-[#0078d4] hover:underline">Reactivate</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
